
    var riot = require('riot')
    //src: starling/src/tags/menu/accept-request-access-menu.html
riot.tag2('accept-request-access-menu',
  '<ul class="floating-menu_list"> <li class="floating-menu_item" onclick="{handleClick.bind(this, \'edit\')}"> <svg class="floating-menu_icon"> <use xlink:href="#edit-icon"></use> </svg> <span class="floating-menu_label"> Can edit </span> </li> <li class="floating-menu_item" onclick="{handleClick.bind(this, \'comment\')}"> <svg class="floating-menu_icon"> <use xlink:href="#comment-icon"></use> </svg> <span class="floating-menu_label"> Can comment </span> </li> <li class="floating-menu_item floating-menu_item--iconless" onclick="{handleClick.bind(this, \'view\')}"> <span class="floating-menu_label"> Can view </span> </li> </ul>',
  '',
  'show="{isOpen}" class="floating-menu floating-menu--small floating-menu--right floating-menu--fixed"', function(opts) {
"use strict";

var _this = this;

var root = this.root;
var _opts = opts,
    canvas = _opts.canvas;

canvas.acceptRequestAccessMenu = this;

this.isOpen = false;
this.collab = null;

this.positionSelf = function (_ref) {
  var selfEl = _ref.selfEl,
      referenceEl = _ref.referenceEl;

  var referenceRect = referenceEl.getBoundingClientRect();
  selfEl.style = "top: " + (referenceRect.bottom + 4) + "px; left: " + referenceRect.right + "px;";
};

this.summon = function (_ref2) {
  var collab = _ref2.collab,
      referenceEl = _ref2.referenceEl;

  _this.isOpen = true;
  _this.collab = collab;

  _this.positionSelf({
    selfEl: root,
    referenceEl: referenceEl
  });

  _this.update();
};

this.hide = function () {
  _this.isOpen = false;
  _this.collab = null;
  _this.update();
};

this.isOpenForUser = function (collab) {
  if (!_this.isOpen) return false;
  if (!_this.collab) return false;
  if (_this.collab.userId && collab.userId && _this.collab.userId === collab.userId) return true;
  if (_this.collab.inviteId && collab.inviteId && _this.collab.inviteId === collab.inviteId) return true;
  return false;
};

this.handleClick = function (permission, e) {
  var collab = _this.collab;
  var userId = collab.id;

  if (!collab) return;

  $.post("/api/maps/" + window.access.publicIdentifier + "/grant-access", { userId: userId, permission: permission }).done(function () {
    var inviteSharePanel = canvas.inviteSharePanel,
        shareModal = canvas.shareModal;
    var collaboratorsPending = inviteSharePanel.collaboratorsPending;

    var filteredCollaborators = collaboratorsPending.filter(function (pending) {
      return pending !== collab;
    });

    shareModal.update({ collaboratorsPending: filteredCollaborators });
    inviteSharePanel.update({ collaboratorsPending: filteredCollaborators });
  });

  _this.hide();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('accept-request-access-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/accept-request-access-menu.html
// module id = 803
// module chunks = 0